/**
 * Mealtime chips on the Tray Ticket Visualizer ribbon.
 *
 * Wrap freely, keep a 32px hit box (36 on coarse pointers via
 * responsive.css), and drop the MUI default of collapsing a group's inner
 * corners. These read as separate chips, not one welded segmented bar,
 * because up to eight of them can wrap onto two rows and a welded bar that
 * wraps looks broken.
 *
 * Why the `&&` selectors: theme/globalStyles.css turns every
 * ToggleButtonGroup into a segmented bar with
 *   .MuiToggleButtonGroup-root .MuiToggleButton-root:first-of-type
 *   .MuiToggleButtonGroup-root .MuiToggleButton-root:last-of-type
 * both `!important` at specificity 0,3,0. A plain `& .MuiToggleButton-root`
 * rule here is only 0,2,0, so it lost for the first and last chip: the first
 * chip came out square on the right and the last one square on the left
 * (Jeff, 2026-09-28: "why are some rounded and some boxed?", most visible
 * on "8:00 pm" when it wrapped to a second row on its own). Doubling the
 * group's class (`&&`) and naming the same pseudo-classes lifts these rules
 * to 0,4,0 so every chip keeps the same pill shape. The group also drops the
 * global `overflow: hidden`, which clipped the chips' focus rings.
 */
export const TTV_MEALTIME_CHIP_RADIUS = '16px !important';

export const TTV_MEALTIME_CHIPS = {
  flexWrap: 'wrap',
  gap: 0.5,
  maxWidth: 420,
  '&&': {
    overflow: 'visible',
  },
  '& .MuiToggleButton-root': {
    textTransform: 'none',
    fontSize: 12,
    lineHeight: 1.2,
    padding: '5px 10px',
    minHeight: 32,
    border: '1px solid',
    borderColor: 'divider',
    whiteSpace: 'nowrap',
  },
  '&& .MuiToggleButton-root, && .MuiToggleButton-root:first-of-type, && .MuiToggleButton-root:last-of-type': {
    borderRadius: TTV_MEALTIME_CHIP_RADIUS,
  },
  '& .MuiToggleButton-root.Mui-selected': {
    bgcolor: 'primary.main',
    color: 'primary.contrastText',
    borderColor: 'primary.main',
    '&:hover': { bgcolor: 'primary.dark' },
  },
} as const;
